import React, { ReactNode } from "react";
import styles from './OrderIntro.module.scss'
import OrderSteps from "./OrderSteps";

export default (
  {
    eyebrow,
    title,
    intro,
    steps,
    outro,
  }: {
    eyebrow?: string;
    title: string;
    intro?: ReactNode;
    steps: ReactNode[];
    outro?: ReactNode;
  }) => {

  return <div className={styles.intro}>
    <header className={styles.header}>
      {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
      <h1>{title}</h1>
      {intro && <p className={styles.lead}>{intro}</p>}
    </header>

    <OrderSteps steps={steps} />

    {outro && <p className={styles.outro}>{outro}</p>}
  </div>
}
